import { render, staticRenderFns } from "./CenterPaymentMethod.vue?vue&type=template&id=01050498&"
import script from "./CenterPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./CenterPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports